import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { checks, collect } from "@/lib/validation";
import { useAuth } from "@/context/AuthContext";
import { Section } from "@/components/ui-brand";

import { Field } from "@/components/panel";

export default function Cuenta() {
  const { user, loginToken } = useAuth();
  const [f, setF] = useState({ current: "", nueva: "", repetir: "" });
  const [busy, setBusy] = useState(false);
  const [errs, setErrs] = useState({});

  const submit = async (e) => {
    e.preventDefault();
    const errs = collect({ current: checks.required(f.current, "Ingresá tu contraseña actual"), nueva: checks.password(f.nueva),
      repetir: f.nueva !== f.repetir ? "Las contraseñas nuevas no coinciden" : null });
    setErrs(errs);
    if (Object.keys(errs).length) return toast.error(Object.values(errs)[0]);
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: f.current, new_password: f.nueva });
      // old token is now revoked server-side; adopt the fresh token so we stay logged in
      if (r.data?.access_token) await loginToken(r.data.access_token, r.data.refresh_token);
      toast.success("Contraseña actualizada");
      setF({ current: "", nueva: "", repetir: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo cambiar la contraseña");
    } finally { setBusy(false); }
  };

  return (
    <Section className="py-14 max-w-md">
      <div className="card-brand p-7 sm:p-8" data-testid="change-password-form">
        <h1 className="h-section text-2xl mb-1">Cambiar contraseña</h1>
        <p className="text-sm text-[var(--brand-text-muted)] mb-6">{user?.email}</p>
        <form onSubmit={submit} noValidate className="space-y-3">
          <Field label="Contraseña actual" type="password" error={errs.current} value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} data-testid="current-password" />
          <Field label="Nueva contraseña" type="password" error={errs.nueva} value={f.nueva} onChange={(e) => setF({ ...f, nueva: e.target.value })} placeholder="Mín. 8 caracteres, con letras y números" data-testid="new-password" />
          <Field label="Repetir nueva contraseña" type="password" error={errs.repetir} value={f.repetir} onChange={(e) => setF({ ...f, repetir: e.target.value })} data-testid="new-password-2" />
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="change-password-submit">{busy ? "Guardando…" : "Actualizar contraseña"}</button>
        </form>
      </div>
    </Section>
  );
}
